import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    FormControlLabel,
    Grid,
    Switch,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";

import DefaultApiService from "../../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../../components/shared/dropdown";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("لطفا این فیلد را پر کنید."),
  priority: Yup.number().required("لطفا این فیلد را پر کنید."),
  daysRequired: Yup.number().required("لطفا این فیلد را پر کنید."),
  stepDescription: Yup.string().required("لطفا این فیلد را پر کنید."),
  adminAlertText: Yup.string().required("لطفا این فیلد را پر کنید."),
  customerAlertText: Yup.string().required("لطفا این فیلد را پر کنید."),
  isActive: Yup.bool(),
  showToCustomer: Yup.bool(),
});

const IndividualBranchingStepInfoModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/SLN/Management/IndividualBranchingStepInfo");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data.stepInfo, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "SLN/Management/IndividualBranchingStepInfo",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        console.log(res);
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      const errorList = error?.response?.data;
      if (typeof errorList === "object") {
        for (const key in errorList) {
          if (Object.hasOwnProperty.call(errorList, key)) {
            const list = errorList[key];
            toast.error(list[0]);
          }
        }
      } else toast.error("خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create" ? `ویرایش ${data?.stepInfo.title}` : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={{
                ...data.stepInfo,
                isActive: Boolean(data.stepInfo?.isActive),
                showToCustomer: Boolean(data.stepInfo?.showToCustomer),
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name] || "",
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="عنوان"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("title")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="اولویت"
                          type="number"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("priority")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="زمان بهینه(روز)"
                          type="number"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("daysRequired")}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="لینک صفحه"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("url")}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <DropdownPicker
                          label="انتخاب مرحله"
                          onChange={(event) => {
                            setFieldValue(
                              "powerPlantProjectStep",
                              event.target.value
                            );
                          }}
                          onBlur={handleBlur}
                          list={data.powerPlantProjectStep}
                          filterable={false}
                          {...onMakeFormikVariable("powerPlantProjectStep")}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <DropdownPicker
                          label="نوع کاربر"
                          onChange={(event) => {
                            setFieldValue("ownerUserKind", event.target.value);
                          }}
                          onBlur={handleBlur}
                          list={data.ownerUserKind}
                          filterable={false}
                          {...onMakeFormikVariable("ownerUserKind")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          label="پیام مدیر"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("adminAlertText")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          label="پیام متقاضی"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("customerAlertText")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <TextField
                          label="شرح"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("stepDescription")}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <FormControlLabel
                          name="isActive"
                          checked={Boolean(values.isActive)}
                          onChange={(event) => {
                            setFieldValue("isActive", event.target.checked);
                          }}
                          control={<Switch />}
                          label="فعال"
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <FormControlLabel
                          name="showToCustomer"
                          checked={Boolean(values.showToCustomer)}
                          onChange={(event) => {
                            setFieldValue(
                              "showToCustomer",
                              event.target.checked
                            );
                          }}
                          control={<Switch />}
                          label="نمایش برای کاربر"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"space-between"}
                      >
                        <Box>
                          <Button
                            variant="outlined"
                            size="large"
                            color="gray"
                            onClick={onNavigateToListPage}
                          >
                            انصراف
                          </Button>
                        </Box>

                        <Box>
                          <Button
                            disabled={isSubmitting}
                            variant="contained"
                            type="submit"
                            size="large"
                          >
                            {loading && (
                              <CircularProgress size={16} color="inherit" />
                            )}
                            {roleId !== "create" ? "ثبت" : "ایجاد"}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default IndividualBranchingStepInfoModifyPage;
